module.exports = __webpack_public_path__ + "static/media/barcode-alt.486cf826.svg";